import * as Yup from 'yup';

export const schema = Yup.object().shape({
  WheelItemLabel: Yup.string().required('وارد کردن عنوان الزامی است'),
  WheelItemDescription: Yup.string().required('وارد کردن توضیحات الزامی است'),
  WheelItemImage: Yup.string().required('انتخاب تصویر الزامی است'),
  WheelItemPopupImage: Yup.string().required('انتخاب تصویر اعلان الزامی است'),

  WheelItemQuantity: Yup.number()
    .typeError('لطفا تعداد را بصورت عدد وارد کنید')
    .min(0, 'مقدار باید 0 یا بیشتر باشد')
    .required('وارد کردن تعداد الزامی است'),

  WheelItemProbability: Yup.number()
    .typeError('لطفا احتمال رویداد را بصورت عدد وارد کنید')
    .min(0, 'مقدار باید 0 یا بیشتر باشد')
    .required('وارد کردن احتمال رویداد الزامی است'),

  WheelItemOrder: Yup.number()
    .typeError('لطفا ترتیب را بصورت عدد وارد کنید')
    .min(0, 'مقدار باید 0 یا بیشتر باشد')
    .required('وارد کردن ترتیب الزامی است'),

  WheelItemReward: Yup.number()
    .typeError('لطفا تعداد جایزه را بصورت عدد وارد کنید')
    .min(0, 'مقدار باید 0 یا بیشتر باشد')
    .required('وارد کردن تعداد جایزه الزامی است'),
});
